import AbstractPage from './abstract-page';
import ShareComponent from '../../share';
import PassedTests from '../../passed-tests';

import {createRef} from 'preact';

export default class Comment extends AbstractPage {
  constructor(props) {
    super(props);

    this.oncloseButtonClick = this.oncloseButtonClick.bind(this);
  }

  popup = createRef();
  gameScreen = createRef();

  oncloseButtonClick = function () {
    this.popup.current.classList.add('js-hidden');
  };

  componentDidMount() {
    if (document.documentElement.clientWidth < 730) {
      document.querySelector('.footer').style.marginTop = `${this.gameScreen.current.scrollHeight}px`;
    }
  }

  componentDidUpdate() {
    if (document.documentElement.clientWidth < 730) {
      document.querySelector('.footer').style.marginTop = `${this.gameScreen.current.scrollHeight}px`;
    }
  }

  render() {
    const commentData = this.screenData;
    const mainHeader = (this.props.data.title) ? <h1 className="content__game-title">{this.props.data.title}</h1> : '';
    const questionCounter = (this.progress) ? Array(this.progress.numberOfQuestion).fill().map((element, i) => (i <= this.progress.questionNumber - 1) ? <span className="content__counter-bar content__counter-bar_passed" key={i}></span> : <span className="content__counter-bar" key={i}></span>) : '';
    const buttonText = (commentData.buttonText) ? commentData.buttonText : 'Ответить';
    const buttons = (commentData.button) ? <div className="content__progress-buttons">
      <button className="content__progress-button content__progress-button_back" type="button" onClick={() => this.onNext(this.screenData.next)} aria-label={buttonText}><svg className="content__progress-button-img" width="32" height="32" viewBox="0 0 32 32"><use xlinkHref="#arrow"></use></svg></button>
      <button className="content__progress-button content__progress-button_forward" type="button" onClick={() => this.onNext(this.screenData.next, 'reload')} aria-label={buttonText}><span className="content__progress-button-text">{buttonText}</span><svg className="content__progress-button-img" width="32" height="32" viewBox="0 0 32 32"><use xlinkHref="#arrow"></use></svg></button>
    </div> : '';
    const subHeader = (this.props.data.description) ? <span>{this.props.data.description}</span> : '';
    const commentAnswers = (commentData.answerList) ? commentData.answerList.map((answer) => {
      return answer[1] ? <li className="content__answer-item content__answer-item_selected"><p className="content__answer content__answer_selected">{answer[0]}</p></li> : <li className="content__answer-item"><p className="content__answer">{answer[0]}</p></li>;
    }) : '';
    const commentDescription = (commentData.description)
      ? <p className="content__answer-comment" dangerouslySetInnerHTML={{__html: commentData.description}}></p>
      : '';
    const textAfter = (commentData.textAfter) ? <div dangerouslySetInnerHTML={{__html: commentData.textAfter}} /> : null;
    const questionDescription = (commentData.comment) ? <div className="content__main-text" dangerouslySetInnerHTML={{__html: commentData.comment}} /> : '';
    const shareButton = (commentData.shareButton) ? <div class="content__share share share__last last__share-content">
      <ShareComponent {...commentData.shareButton}/>
    </div> : null;
    const reference = (commentData.ref) ? (commentData.ref) : '#';
    const passedTests = commentData.testId ? <PassedTests testId={commentData.testId}/> : null;


    return (
      <article ref={this.gameScreen} className={commentData.specialClass}>
        {mainHeader}
        <div className="content__counter">
          {questionCounter}
        </div>
        {questionDescription}
        {subHeader}
        <ul className="content__answer-list">
          {commentAnswers}
        </ul>
        {commentDescription}
        {passedTests}
        {buttons}
        {textAfter}
        {shareButton}
      </article>
    );
  }

  static backDataToModel(step) {
    const result = AbstractPage.backDataToModel(step);
    result.button = (step.button) ? step.button : null;
    result.buttonText = (step.buttonText) ? step.buttonText : null;
    result.next = (step.next) ? step.next : null;
    result.textAfter = (step.textAfter) ? step.textAfter : null;
    result.testId = (step.testId) ? step.testId : null;
    result.answerList = (step.answerList && step.answerList.length) ? step.answerList : null;
    return result;
  }
}



// WEBPACK FOOTER //
// ./components/page/view/comment.js